export interface LotteryCategory {
  id: string;
  slug: string;
  name: string;
  icon: string;
  color: string;
  description: string;
  shortDesc: string;
  thumbnailUrl: string;
  drawDays: string;
  drawTime: string;
  minPrice: number;
  rules: string[];
  odds: { prize: string; amount: string; condition: string }[];
  tips: string[];
  latestResult?: {
    period: string;
    date: string;
    numbers: string[];
  };
  imageSeq: string;
}

export const lotteryCategories: LotteryCategory[] = [
  {
    id: 'ssq',
    slug: 'shuangseqiu',
    name: '双色球',
    icon: 'ri-billiards-line',
    color: '#D4380D',
    description: '双色球是中国福利彩票的明星玩法，每周二、四、日晚开奖。从33个红球中选6个，从16个蓝球中选1个，中一个蓝球即有奖。头奖奖金最高可达1000万元，是中国最受欢迎的彩票玩法之一。',
    shortDesc: '双色球，大奖大、小奖多，2元赢取千万大奖',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Red%20and%20blue%20lottery%20balls%20floating%20on%20warm%20golden%20abstract%20background%20with%20bokeh%20effect%2C%20lucky%20atmosphere%2C%20clean%20modern%20design&width=600&height=300&seq=lottery-card-shuangseqiu&orientation=landscape',
    drawDays: '每周二、四、日',
    drawTime: '21:15',
    minPrice: 2,
    rules: [
      '从01-33共33个红色球号码中选取6个号码',
      '从01-16共16个蓝色球号码中选取1个号码',
      '每注金额人民币2元',
      '可进行单式投注、复式投注和胆拖投注',
    ],
    odds: [
      { prize: '一等奖', amount: '最高1000万元', condition: '6红+1蓝全中' },
      { prize: '二等奖', amount: '浮动奖金', condition: '6红全中' },
      { prize: '三等奖', amount: '3000元', condition: '5红+1蓝' },
      { prize: '四等奖', amount: '200元', condition: '5红 或 4红+1蓝' },
      { prize: '五等奖', amount: '10元', condition: '4红 或 3红+1蓝' },
      { prize: '六等奖', amount: '5元', condition: '中1蓝球' },
    ],
    tips: [
      '建议选择复式投注，提高中奖概率',
      '关注历史冷热号分布，合理选号',
      '理性购彩，量力而行，切勿沉迷',
    ],
    latestResult: {
      period: '2024095',
      date: '2024-08-06',
      numbers: ['05', '12', '18', '25', '29', '31', '09'],
    },
    imageSeq: 'shuangseqiu-card',
  },
  {
    id: 'dlt',
    slug: 'daletou',
    name: '大乐透',
    icon: 'ri-star-smile-line',
    color: '#D4880D',
    description: '超级大乐透是国家体育总局体育彩票管理中心的明星产品，每周一、三、六晚开奖。从前区35个号码中选5个，从后区12个号码中选2个。头奖奖金最高可突破亿元，是中国彩票史上诞生亿元大奖最多的玩法。',
    shortDesc: '超级大乐透，亿元大奖的摇篮',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Golden%20lottery%20balls%20with%20warm%20amber%20lighting%20on%20elegant%20abstract%20background%2C%20luxurious%20feeling%2C%20celebration%20theme&width=600&height=300&seq=lottery-card-daletou&orientation=landscape',
    drawDays: '每周一、三、六',
    drawTime: '20:25',
    minPrice: 2,
    rules: [
      '从前区01-35共35个号码中选取5个号码',
      '从后区01-12共12个号码中选取2个号码',
      '每注金额人民币2元',
      '支持追加投注，追加后每注3元，一二等奖奖金增加80%',
    ],
    odds: [
      { prize: '一等奖', amount: '最高可超亿元', condition: '5前区+2后区全中' },
      { prize: '二等奖', amount: '浮动奖金', condition: '5前区+1后区' },
      { prize: '三等奖', amount: '10000元', condition: '5前区' },
      { prize: '四等奖', amount: '3000元', condition: '4前区+2后区' },
      { prize: '五等奖', amount: '300元', condition: '4前区+1后区' },
      { prize: '六等奖', amount: '200元', condition: '3前区+2后区' },
      { prize: '七等奖', amount: '100元', condition: '4前区' },
      { prize: '八等奖', amount: '15元', condition: '3前区+1后区 或 2前区+2后区' },
      { prize: '九等奖', amount: '5元', condition: '其他中奖情况' },
    ],
    tips: [
      '追加投注是提高大奖回报的有效方式',
      '复式+追加组合投注，中奖收益更高',
      '合理规划购彩预算，享受健康购彩生活',
    ],
    latestResult: {
      period: '24091',
      date: '2024-08-05',
      numbers: ['08', '15', '22', '31', '35', '03', '11'],
    },
    imageSeq: 'daletou-card',
  },
  {
    id: 'ks',
    slug: 'kuaisan',
    name: '快三',
    icon: 'ri-speed-up-line',
    color: '#0891B2',
    description: '快三是一种高频快开型彩票玩法，每天多期开奖，几分钟即可知晓中奖结果。从1-6共6个号码中任选3个号码进行投注（可重复），玩法简单有趣，中奖频率高，深受年轻彩民喜爱。',
    shortDesc: '快三高频开奖，几分钟一开，即开即兑超刺激',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Fast%20motion%20dice%20with%20dynamic%20lighting%20on%20warm%20dark%20background%2C%20speed%20and%20excitement%20theme%2C%20modern%20gaming%20aesthetic&width=600&height=300&seq=lottery-card-kuaisan&orientation=landscape',
    drawDays: '每日多期（10分钟一期）',
    drawTime: '全天滚动开奖',
    minPrice: 2,
    rules: [
      '从1-6共6个号码中任选3个号码（可重复选择）',
      '每注金额人民币2元',
      '多种玩法：和值、三同号、二同号、三不同号等',
      '每日多期开奖，开奖频率高',
    ],
    odds: [
      { prize: '三同号单选', amount: '240元', condition: '三个号码相同且与开奖一致' },
      { prize: '三同号通选', amount: '40元', condition: '开奖为任意三同号' },
      { prize: '二同号单选', amount: '80元', condition: '两个号码相同' },
      { prize: '二同号复选', amount: '15元', condition: '猜中同号' },
      { prize: '三不同号', amount: '40元', condition: '三个号码各不相同' },
      { prize: '和值', amount: '9-240元', condition: '猜中和值大小' },
    ],
    tips: [
      '快三玩法简单，适合新手入门体验',
      '和值玩法覆盖面广，中奖概率相对较高',
      '高频开奖请注意控制投注节奏，理性参与',
    ],
    latestResult: {
      period: '20240806089',
      date: '2024-08-06 14:30',
      numbers: ['3', '3', '6'],
    },
    imageSeq: 'kuaisan-card',
  },
  {
    id: 'fc3d',
    slug: 'fucai3d',
    name: '福彩3D',
    icon: 'ri-dice-line',
    color: '#7C3AED',
    description: '福彩3D是中国福利彩票的经典数字型玩法，每天开奖一次。从000-999共1000个三位数中选择一个进行投注，玩法简单直观。支持单选、组选等多种投注方式，中奖概率高，奖金稳定，是最受欢迎的数字彩之一。',
    shortDesc: '福彩3D，数字游戏的经典之选',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Colorful%20lottery%20number%20balls%20on%20warm%20abstract%20background%20with%20soft%20golden%20lighting%2C%20modern%20clean%20design%2C%20lucky%20atmosphere&width=600&height=300&seq=lottery-card-fucai3d&orientation=landscape',
    drawDays: '每日开奖',
    drawTime: '21:15',
    minPrice: 2,
    rules: [
      '从000-999中选择一个三位数进行投注',
      '每注金额人民币2元',
      '支持单选、组选三、组选六等投注方式',
      '单选需三个数字及位置全对，组选不要求位置',
    ],
    odds: [
      { prize: '单选', amount: '1040元', condition: '三个数字及位置完全一致' },
      { prize: '组选三', amount: '346元', condition: '有两个数字相同' },
      { prize: '组选六', amount: '173元', condition: '三个数字各不相同' },
    ],
    tips: [
      '组选投注中奖概率更高，适合稳健型彩民',
      '关注和值走势、跨度分析等数据指标',
      '每日开奖，养成理性投注的好习惯',
    ],
    latestResult: {
      period: '2024208',
      date: '2024-08-05',
      numbers: ['4', '7', '1'],
    },
    imageSeq: 'fucai3d-card',
  },
  {
    id: 'pl3',
    slug: 'pailiesan',
    name: '排列三',
    icon: 'ri-number-3',
    color: '#2563EB',
    description: '排列三是体育彩票的经典数字型玩法，每日开奖。与福彩3D类似，从000-999中选择一个三位数。排列三最大的特色是支持直选、组选等多种灵活投注方式，以及倍投功能，满足不同彩民的需求。',
    shortDesc: '排列三，体彩数字游戏的明星玩法',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Number%20lottery%20balls%20with%20warm%20golden%20accents%20on%20abstract%20soft%20background%2C%20clean%20modern%20design%2C%20professional%20atmosphere&width=600&height=300&seq=lottery-card-pailiesan&orientation=landscape',
    drawDays: '每日开奖',
    drawTime: '20:25',
    minPrice: 2,
    rules: [
      '从000-999中选择一个三位数进行投注',
      '每注金额人民币2元',
      '支持直选、组选三、组选六等投注方式',
      '支持多倍投注，最高可投99倍',
    ],
    odds: [
      { prize: '直选', amount: '1040元', condition: '三个数字及位置完全一致' },
      { prize: '组选三', amount: '346元', condition: '有两个数字相同' },
      { prize: '组选六', amount: '173元', condition: '三个数字各不相同' },
    ],
    tips: [
      '直选+组选组合投注，中奖更稳妥',
      '倍投功能让您的中奖收益翻倍',
      '保持平常心，享受数字游戏的乐趣',
    ],
    latestResult: {
      period: '24208',
      date: '2024-08-05',
      numbers: ['6', '2', '9'],
    },
    imageSeq: 'pailiesan-card',
  },
  {
    id: 'ssc',
    slug: 'shishicai',
    name: '时时彩',
    icon: 'ri-time-line',
    color: '#059669',
    description: '时时彩是一种全天高频开奖的数字彩票，每天多期开奖。从0-9中选号组成五星、四星、三星等不同玩法。开奖频率高，玩法丰富多样，是中高级彩民热衷的数字竞技场。支持大小单双、和值、跨度等多种趣味投注方式。',
    shortDesc: '时时彩高频开奖，多种趣味玩法任您选',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Digital%20lottery%20concept%20with%20glowing%20numbers%20on%20warm%20dark%20abstract%20background%2C%20modern%20technology%20aesthetic%2C%20dynamic%20atmosphere&width=600&height=300&seq=lottery-card-shishicai&orientation=landscape',
    drawDays: '每日多期',
    drawTime: '全天滚动开奖',
    minPrice: 2,
    rules: [
      '从0-9中选择号码组成不同位数的投注',
      '每注金额人民币2元',
      '支持五星、四星、三星、二星、一星等玩法',
      '还可投注大小单双、和值、跨度等趣味玩法',
    ],
    odds: [
      { prize: '五星直选', amount: '100000元', condition: '五位号码及位置全中' },
      { prize: '四星直选', amount: '10000元', condition: '四位号码及位置全中' },
      { prize: '三星直选', amount: '1000元', condition: '三位号码及位置全中' },
      { prize: '二星直选', amount: '100元', condition: '两位号码及位置全中' },
      { prize: '一星', amount: '10元', condition: '一位号码及位置正确' },
      { prize: '大小单双', amount: '4元', condition: '猜中一位的大小或单双' },
    ],
    tips: [
      '时时彩玩法灵活，适合有一定经验的老彩民',
      '大小单双玩法简单，中奖概率较高',
      '高频开奖需格外注意理性投注，控制节奏',
    ],
    imageSeq: 'shishicai-card',
  },
];

export const getCategoryBySlug = (slug: string): LotteryCategory | undefined => {
  return lotteryCategories.find((c) => c.slug === slug);
};